
<div :id="id" class="h-100" data-simplebar>
  <slot></slot>
</div>
